import { Checkbox, Link, TableCell, TableRow } from '@amzn/meridian';
import type { LdapPermissionsTableRowPermissionLdapDataFragment } from 'generated/graphql';
import type { FC } from 'react';
import { formatPermissionString } from '../../TPShareModalUtil';
import { LDAPPermissionRowLDAPGroupNameCell } from './cells/LDAPPermissionRowLDAPGroupNameCell';

export type LDAPPermissionsTableRowProps = {
  ldapData: LdapPermissionsTableRowPermissionLdapDataFragment;
  onChangeRow: (value: boolean) => void;
  selected: (group: LdapPermissionsTableRowPermissionLdapDataFragment['ldapGroup']) => void;
  onRemove: (group: LdapPermissionsTableRowPermissionLdapDataFragment['ldapGroup']) => void;
};

export const LDAPPermissionsTableRow: FC<LDAPPermissionsTableRowProps> = ({ ldapData, onChangeRow, selected, onRemove }) => (
  <TableRow>
    <TableCell>
      <Checkbox checked={selected(ldapData.ldapGroup)} onChange={onChangeRow} />
    </TableCell>
    <LDAPPermissionRowLDAPGroupNameCell ldapData={ldapData} />
    <TableCell>{formatPermissionString(ldapData.action)}</TableCell>
    <TableCell>
      <Link onClick={() => onRemove(ldapData.ldapGroup)} type="secondary">
        Remove
      </Link>
    </TableCell>
  </TableRow>
);
